import {
  CLOSED_SALES_STATUSES,
  useClosedSalesStore,
} from '@/features/closed-sales';
import { ROUTE_PATHS } from '@/shared/constants';
import { useFeatureFlagsStore } from '@/store/featureFlags';
import { defineNuxtMiddleware } from '@/types/nuxt2CompositionApiShims';
import type { User } from '@/types/User';

import { getFiredRedirectPath } from './fired';

export default defineNuxtMiddleware(({
  store,
  redirect,
  route,
  error,
}) => {
  if (route.query.errorView === '1') {
    error({ statusCode: 500 });
    return;
  }

  const user: User | undefined = store.state.auth?.user;

  if (!user) {
    return;
  }

  const firedRedirectPath = getFiredRedirectPath(user, route.name);

  if (firedRedirectPath) {
    return redirect(firedRedirectPath);
  }

  const { hasClosedSalesFlag } = useFeatureFlagsStore();

  if (!hasClosedSalesFlag()) {
    return redirect(ROUTE_PATHS.deals);
  }

  const { statusClosedSales } = useClosedSalesStore();

  if (statusClosedSales === CLOSED_SALES_STATUSES.none) {
    return redirect(ROUTE_PATHS.closedSales);
  }

  return redirect(ROUTE_PATHS.deals);
});
